<template>
  <div class="cloudUserMonitorSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Input
          v-model="cloudUserName"
          :placeholder="$t('alarms.cloudUser.title')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:cloudUserMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableCloudUser from "../cloud_user/TableCloudUser";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tableCloudUser = TableCloudUser;
export default {
  name: "CloudUserMonitorSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      stateSearchKey: [],
      regionList: [],
      regionName: "",
      cloudUserName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("cloudUserName", this.cloudUserName);
      tableCloudUser.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.cloudUserMonitorSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/cloud_user/CloudUserMonitorSearch.vue